import { Pipe, PipeTransform } from '@angular/core';
import { NavItemModel } from '@core/models/nav-item.model';
import { SettingsAsObject, SettingsParamValue } from '@core/models/settings.model';
import { RouteEntity } from '@core/router/router.entity';


@Pipe({
    name: 'navItemAccess',
    standalone: true,
})
export class NavItemAccessPipe implements PipeTransform {
    public transform(navItems: NavItemModel[], ...args: [SettingsAsObject]): NavItemModel[] {
        const settings: SettingsAsObject = args[0];

        return navItems.filter((menuItem: NavItemModel) => this.checkAccessMenuItem(menuItem.path.join(''), settings));
    }

    private checkAccessMenuItem(path: string, settings: SettingsAsObject): boolean {
        switch (path) {
            case RouteEntity.Root + RouteEntity.Map:
                return settings.CLIENT_HIDE_MAP_PAGE !== SettingsParamValue.Y;
            case RouteEntity.Root + RouteEntity.Topup:
                return settings.CLIENT_WALLET_REG === SettingsParamValue.Y;
            default:
                return true;
        }
    }
}
